import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';

export const THANK_YOU_BLOCK_TARGET = 'purchase.thank-you.block.render';
export const ORDER_STATUS_BLOCK_TARGET = 'customer-account.order-status.block.render';

export const findThemeAppExtension = (extensions: ExtensionInfo[]) =>
    extensions?.find((extension) => extension.type === 'theme_app_extension');

export const findExtensionByHandle = (extensions: ExtensionInfo[], handle: string) =>
    extensions?.find((extension) => extension.handle === handle);

export const findCheckoutMapExtension = (extensions: ExtensionInfo[]) =>
    findExtensionByHandle(extensions, 'ppoint-checkout-ui');

export const findThankYouPageMapExtension = (extensions: ExtensionInfo[]) =>
    findExtensionByHandle(extensions, 'ppoint-thank-you-map');

export const findThankYouPageExtension = (extensions: ExtensionInfo[]) =>
    findExtensionByHandle(extensions, 'ppoint-checkout-thank-you');

export const hasAppsEmbedBlock = (themeAppExtension: ExtensionInfo) =>
    themeAppExtension?.activations.find((activation) => activation.handle === 'pickup-app-embed-block')?.status ===
    'active';

export const hasBlockEmbed = (themeAppExtension: ExtensionInfo) =>
    themeAppExtension?.activations.find((activation) => activation.handle === 'pickup-app-block')?.status === 'active';

export const hasCheckoutMap = (checkoutMapIntegration: ExtensionInfo) =>
    !!checkoutMapIntegration?.activations.find((activation) => activation?.target);

export const hasThankYouPageMap = (thankYouPageMapIntegration: ExtensionInfo) =>
    !!thankYouPageMapIntegration?.activations.find((activation) => activation.target === THANK_YOU_BLOCK_TARGET);

export const hasOrderStatusPageMap = (orderStatusPageMapIntegration: ExtensionInfo) =>
    !!orderStatusPageMapIntegration?.activations.find((activation) => activation.target === ORDER_STATUS_BLOCK_TARGET);

export const hasThankYouPage = (thankYouPageIntegration: ExtensionInfo) =>
    !!thankYouPageIntegration?.activations.find((activation) => activation.target === THANK_YOU_BLOCK_TARGET);

export const hasCustomerAccountPage = (customerAccountPageIntegration: ExtensionInfo) =>
    !!customerAccountPageIntegration?.activations.find((activation) => activation.target === ORDER_STATUS_BLOCK_TARGET);
